var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computeLazyDistribution, currencyIdToMonetaryCurrency, decodeFixedPointType, newMonetaryAmount, newVaultId, } from "../utils";
export class DefaultRewardsAPI {
    constructor(api, wrappedCurrency) {
        this.api = api;
        this.wrappedCurrency = wrappedCurrency;
    }
    getStakingPoolNonce(collateralCurrency, vaultAccountId) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultId = newVaultId(this.api, vaultAccountId.toString(), collateralCurrency, this.wrappedCurrency);
            const rawNonce = yield this.api.query.vaultStaking.nonce(vaultId);
            return rawNonce.toNumber();
        });
    }
    computeCollateralInStakingPool(vaultId, nominatorId) {
        return __awaiter(this, void 0, void 0, function* () {
            const collateralCurrency = yield currencyIdToMonetaryCurrency(this.api, vaultId.currencies.collateral);
            const nonce = yield this.getStakingPoolNonce(collateralCurrency, vaultId.accountId);
            const [stake, slashPerToken, slashTally] = yield this.api
                .queryMulti([
                [this.api.query.vaultStaking.stake, [nonce, [vaultId, nominatorId]]],
                [this.api.query.vaultStaking.slashPerToken, [nonce, vaultId]],
                [this.api.query.vaultStaking.slashTally, [nonce, [vaultId, nominatorId]]],
            ])
                .then((data) => data.map((value) => decodeFixedPointType(value)));
            const toSlash = computeLazyDistribution(stake, slashPerToken, slashTally);
            return newMonetaryAmount(stake.sub(toSlash), yield currencyIdToMonetaryCurrency(this.api, vaultId.currencies.collateral));
        });
    }
    withdrawRewards(vaultId, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const definedNonce = nonce
                ? nonce
                : yield this.getStakingPoolNonce(yield currencyIdToMonetaryCurrency(this.api, vaultId.currencies.collateral), vaultId.accountId);
            const tx = this.api.tx.fee.withdrawRewards(vaultId, definedNonce.toString());
            return { extrinsic: tx, event: this.api.events.vaultStaking.WithdrawReward };
        });
    }
}
//# sourceMappingURL=rewards.js.map